import { useMemo } from 'react';
import { HostPropsContext, type HostPropsContextValue } from './host-props-context';

export function withHostPropsProvider<T extends any>(
  Component: React.ComponentType<T>,
): React.ComponentType<T & HostPropsContextValue> {
  const TypeSafeComponent = Component as React.ComponentType<Omit<T, keyof HostPropsContextValue>>;

  return ({
    basename,
    platform,
    getAuthToken,
    env,
    apiEnv,
    featureFlags,
    jsonFeatureFlags,
    trackEvent,
    trackPageView,
    setTouchPointPage,
    getPreviousTouchPointPage,
    user,
    onNotFound,
    restAPIBaseURL,
    siteCode,
    discardTrialEntrypoint,
    prefetchedQueries,
    pathBuilder,
    authContext,
    ...props
  }) => {
    const value = useMemo<HostPropsContextValue>(
      () => ({
        basename,
        platform,
        getAuthToken,
        env,
        apiEnv,
        featureFlags,
        jsonFeatureFlags,
        trackEvent,
        trackPageView,
        setTouchPointPage,
        getPreviousTouchPointPage,
        user,
        onNotFound,
        restAPIBaseURL,
        siteCode,
        discardTrialEntrypoint,
        prefetchedQueries,
        pathBuilder,
        authContext,
      }),
      [
        basename,
        platform,
        getAuthToken,
        env,
        apiEnv,
        featureFlags,
        jsonFeatureFlags,
        trackEvent,
        trackPageView,
        setTouchPointPage,
        getPreviousTouchPointPage,
        user,
        onNotFound,
        restAPIBaseURL,
        siteCode,
        discardTrialEntrypoint,
        prefetchedQueries,
        pathBuilder,
        authContext,
      ],
    );

    return (
      <HostPropsContext.Provider value={value}>
        <TypeSafeComponent {...props} />
      </HostPropsContext.Provider>
    );
  };
}
